// dnd.ts
import {
    useSensor,
    useSensors,
    DragEndEvent,
    KeyboardSensor,
    MouseSensor,
    TouchSensor
} from "@dnd-kit/core";
import { arrayMove } from "@dnd-kit/sortable";
export const ORDER_STEP = 1000;
export function useFieldDnD(setFields: Function) {
    const sensors = useSensors(
        useSensor(KeyboardSensor), 
        useSensor(MouseSensor, { activationConstraint: { distance: 5 }}),
        useSensor(TouchSensor, { activationConstraint: { delay: 400, tolerance: 5 }})
    );
    function handleDragEnd(event: DragEndEvent) {
        const { active, over } = event;
        if (!over || active.id === over.id) return;
        setFields((prev: any[]) => {
            const oldIndex = prev.findIndex(f => f.field_key === active.id);
            const newIndex = prev.findIndex(f => f.field_key === over.id);
            const reordered = arrayMove(prev, oldIndex, newIndex);
            return reordered.map((f, i) => ({
                ...f,
                sort_order: (i + 1) * ORDER_STEP
            }));
        });
    }
    return { sensors, handleDragEnd };
}
